<script>
    import {
      CurrentBattleLog,
    } from "../stores/gameStore";

    export let sides = 6;  // default to 6-sided dice
    export let result = 0; // the result from the backend
    export let rolling = false; // control when the dice is rolling
    export let index = 0;
    export let who = 'player';
    export let timeForReroll = true;
    let currentFrame = { x: 6, y: 0 };

    let dieType = 'D6';
    $: if (sides == 6) {
        dieType = 'D6';
    } else {
        dieType = 'D12';
    }

    let animationInterval;
  
    // Coordinates for D6 and D12 in the sprite sheet
    const diceFrames = {
      6: {
        values: [
          { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 2, y: 0 }, { x: 3, y: 0 }, 
          { x: 4, y: 0 }, { x: 5, y: 0 }
        ],
        moving: [
          { x: 7, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 1 }, { x: 2, y: 1 }, 
          { x: 3, y: 1 }, { x: 4, y: 1 }
        ],
        noResult: { x: 6, y: 0 }
      },
      12: {
        values: [
          { x: 5, y: 1 }, { x: 6, y: 1 }, { x: 7, y: 1 }, { x: 0, y: 2 }, 
          { x: 1, y: 2 }, { x: 2, y: 2 }, { x: 3, y: 2 }, { x: 4, y: 2 }, 
          { x: 5, y: 2 }, { x: 6, y: 2 }, { x: 7, y: 2 }, { x: 0, y: 3 }
        ],
        moving: [
          { x: 2, y: 3 }, { x: 3, y: 3 }, { x: 4, y: 3 }, { x: 5, y: 3 },
          { x: 6, y: 3 }, { x: 7, y: 3 }
        ],
        noResult: { x: 1, y: 3 }
      }
    };
  
    const frameSize = { width: 100, height: 100 }; // Adjust size based on your sprite sheet
  
    function getFrameStyle(frame) {
      return `-${frame.x * frameSize.width}px -${frame.y * frameSize.height}px`;
    }
  
    function startRolling() {
        let frameIndex = 0;
        const maxFrames = diceFrames[sides].moving.length;

        // Clear any previous interval if it's still running
        if (animationInterval) clearInterval(animationInterval);

        // Start rolling animation
        animationInterval = setInterval(() => {
            currentFrame = diceFrames[sides].moving[frameIndex];
            frameIndex = (frameIndex + 1) % maxFrames;
            }, 65); // Adjust the speed of the frame change
    }

    function stopRolling() {
        clearInterval(animationInterval);

        // Display the result or no result if 0
        if (result === 0) {
        currentFrame = diceFrames[sides].noResult;
        } else {
        currentFrame = diceFrames[sides].values[result - 1];
        }
        // CurrentBattleLog[who].rolledDice[dieType][index].set(false);
    }

    // Function to control how long the dice rolls
    function rollForDuration(duration) {
        startRolling();

        // Set a timeout to automatically stop rolling after `duration` ms
        setTimeout(() => {
        stopRolling();
        }, duration);
    }

    // React to changes in the `rolling` prop
    $: if (rolling && diceFrames[sides]) {
          rollForDuration(1000);
        } else {
          currentFrame =
            result === 0
              ? diceFrames[sides]?.noResult || { x: 1, y: 3 }
              : diceFrames[sides]?.values[result - 1] || diceFrames[sides].noResult;
        }

    // Handle the player dice click event
    function handlePlayerClick(e) {
        e.preventDefault();
        e.stopPropagation();
        window.GAME.bgaPerformAction("reroll", {
        dieType: dieType,
        dieIndex: index
        });
    }

  </script>
  
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    class="dice {(who === 'player' && timeForReroll) ? 'hoverable' : ''}"
    style="background-position: {getFrameStyle(currentFrame)};"
    on:click={(who === 'player' && timeForReroll) ? handlePlayerClick : null}
    >
  </div>

  <style>
    .dice {
      width: 100px; /* Adjust size */
      height: 100px; /* Adjust size */
      background-image: url("img/Spritesheet_Dice.png");
      background-size: 800px 400px; /* Adjust to fit sprite sheet size */
    }

    .hoverable:hover {
        cursor: pointer;
        filter: brightness(1.2);
    }
  </style>